module.exports = __webpack_public_path__ + "static/media/close-small.3b1d9288.svg";